import { render, staticRenderFns } from "./dmca.vue?vue&type=template&id=366aa4bf"
import script from "./dmca.vue?vue&type=script&lang=js"
export * from "./dmca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports